import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["dsf_title", "onNavigate"]

import router from '@/router'
import AppNavigationItems from './AppNavigationItems.vue'
import ProfileMenu from '../AppLayoutHeader/ProfileMenu.vue'
import { useFaqUrl } from '@/components/sennderUrlHelper'
import { analytics } from '@/services/analyticsProvider'
import { ANALYTICS_EVENTS } from '@/services/analyticsEvents'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppLayoutMobileSidebar',
  emits: ['close'],
  setup(__props, { emit }) {



const close = () => {
  emit('close')
}

const navigate = (e: CustomEvent<string>) => {
  const route = e.detail
  if (route) {
    router.push({ path: route })
    window.scrollTo(0, 0)
  }
  close()
}

const onLogoClick = () => {
  router.push({ path: '/' })
  close()
}

const faqUrl = useFaqUrl()

const navigateToFaq = () => {
  window.open(faqUrl.value, '_blank')
  analytics.trackEvent(ANALYTICS_EVENTS.MENU_FAQ_CLICK)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("dsf-navbar", {
    dsf_mobile: "",
    dsf_title: "FOR CARRIERS",
    onNavigate: navigate,
    onClose: close,
    onLogoClick: onLogoClick
  }, [
    _createCommentVNode(" Page navigation items "),
    _createVNode(AppNavigationItems),
    _createElementVNode("dsf-navbar-item", {
      dsf_icon: "HelpCircle",
      dsf_title: _ctx.$t('sidebar.usermenu.help'),
      dsf_id: "faq",
      onNavigate: _withModifiers(navigateToFaq, ["stop"])
    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_1),
    _createCommentVNode(" Profile menu items "),
    _createVNode(ProfileMenu, {
      slot: "footer",
      "mobile-mode": true,
      onClose: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
      onItemClick: close,
      class: "mt-auto"
    })
  ], 32 /* HYDRATE_EVENTS */))
}
}

})